import { EventType, Report } from '@/types/driver-report'
import { uuid } from '@/types/general'

export const stopTypeColors: Partial<Record<EventType, string>> = {
    [EventType.Break]: 'bg-blue-400',
    [EventType.Customer]: 'bg-primary-400',
    [EventType.Other]: 'bg-red-400',
    [EventType.Traffic]: 'bg-yellow-400',
    [EventType.Resting]: 'bg-green-300',
}

export const reportColors = [
    '#069468',
    '#037EA3',
    '#F8BB54',
    '#E76767',
    '#6A8780',
    '#C0DFE8',
    '#829486',
    '#2f7FA8',
    '#E9BF94',
    '#DC2626',
    '#2A534A',
    '#037193',
    '#935F07',
    '#2C323A',
    '#056F4E',
    '#C0DFE8',
    '#51B495',
    '#818892',
    '#4FA5BF',
    '#B3B5B7',
    '#4B5563',
    '#F59E0B',
    '#841717',
    '#939598',
    '#9BD4C3',
    '#B7BBC1',
    '#9ACBDA',
    '#F1A8A8',
    '#FBD89D',
    '#D4D5D6',
]

export function canSettleReport(report: Report, companyId: uuid): boolean {
    if (!report.endedAt) return false
    if (report.settlementId) return false
    if (report.company.id !== companyId) return false
    return true
}
